// =============================================================================
// FILE: packages/renderer/src/components/branding/Footer.tsx
// PURPOSE: Persistent app footer — small, intentional creator credit. Renders
//          on every page via AppShell so the attribution is consistent
//          without dominating the chrome.
// =============================================================================

import type { JSX } from 'react';
import { getBrand } from '@bim/shared/config/brand.config.js';

export function Footer(): JSX.Element {
  const brand = getBrand();
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-zinc-900 bg-zinc-950/70 px-6 py-2.5 text-[10px] text-zinc-600 flex items-center justify-between gap-2"
    >
      <span className="uppercase tracking-[0.22em]">{brand.productName}</span>
      <span>{brand.copyright}</span>
    </footer>
  );
}
